
import React from 'react'
import './github.css'
import GitHubCalendar from 'react-github-calendar'

const Github = () => {
  return (
    <div className='react-activity-calendar '>
      <GitHubCalendar
      username='shivamvr'
      blockSize={15}
      blockMargin={5}
      fontSize={16}
      />
      <div className='stats-wrapper'>
       <div>
        <img id="github-stats-card" src={'https://github-readme-stats.vercel.app/api?username=shivamvr&show_icons=true&card_width=595'}/>
        <img id="github-streak-stats" src={'https://github-readme-streak-stats.herokuapp.com/?user=shivamvr&card_width=595'}/>
       </div>
       <img id="github-top-langs" src={'https://github-readme-stats.vercel.app/api/top-langs/?username=shivamvr'}/>
      </div>
    </div>
  )
}

export default Github